module.exports = __webpack_public_path__ + "img/smart_norms2.de73de40.png";